import { UserInterfaceIdiomProvider } from '@psl/appComponents/UserInterfaceIdiomContext';
import { config } from '@psl/functions/config';
import { ResponsiveContextProvider } from '@psl/functions/responsive/ResponsiveContext';
import * as Updates from 'expo-updates';
import { Platform, SafeAreaView, View } from 'react-native';
import { ThemeProvider } from 'styled-components';
import { theme } from '../../themes/Default';
import Button from '../button/Button';
import { Typography } from '../typography';

let alreadyTriedReset = false;

const ErrorFallback = (props: {
  error: Error | null;
  componentStack: string | null;
  eventId: string | null;
  resetError: () => void;
}) => {
  if (
    Platform.OS === 'web' &&
    props.error?.message.toLowerCase().includes('chunk')
  ) {
    location.reload();
    return <></>;
  }
  return (
    <UserInterfaceIdiomProvider
      name="error-fallback"
      userInterfaceStyle="light"
    >
      <ResponsiveContextProvider>
        <ThemeProvider theme={theme}>
          <SafeAreaView
            css={`
              flex: 1;
              justify-content: center;
              background-color: white;
            `}
          >
            <View
              css={`
                padding: 0 25px;
                align-self: center;
                width: 90%;
                max-width: 500px;
              `}
            >
              <Typography.H1 mb={12}>Oops</Typography.H1>
              <Typography.H3 mb={5}>Something went wrong...</Typography.H3>
              <Typography.Body mb={10}>
                {config.isProd ? props.error?.message : props.error?.stack}
              </Typography.Body>
              {props.eventId != null && (
                <Typography.Body mb={10}>
                  CrashId: {props.eventId}
                </Typography.Body>
              )}
              <Button
                title="Try again"
                onPress={async () => {
                  if (
                    Platform.OS === 'web' &&
                    props.error?.message.toLowerCase().includes('chunk')
                  ) {
                    location.reload();
                    return;
                  }
                  if (!alreadyTriedReset) {
                    alreadyTriedReset = true;
                    props.resetError();
                    return;
                  }
                  if (Platform.OS == 'web') {
                    window.location.reload();
                  } else {
                    await Updates.reloadAsync();
                  }
                }}
                css={`
                  margin: 0 -10px;
                `}
              />
            </View>
          </SafeAreaView>
        </ThemeProvider>
      </ResponsiveContextProvider>
    </UserInterfaceIdiomProvider>
  );
};

export default ErrorFallback;
